import { CheckRoleBasedPermission } from '../../utility/checkRoleBasedPermission';
import { useSelector } from 'react-redux';

const Permission = ({ service, permission, children }) => {
    const auth = useSelector((state) => state.auth);
    const user = auth?.user
    return CheckRoleBasedPermission(user, service, permission) ? children : null;
};

export default Permission;